import {TimezoneObject} from 'common/src/modules/timezones/timezones.types';

function getTimeZoneStringForDateTime(offset?: number | TimezoneObject) {
  const offsetNumber = (typeof offset === 'number' ? offset : offset?.currentOffset) || 0;

  return `UTC${offsetNumber < 0 ? offsetNumber : `+${offsetNumber}`}`;
}

export default getTimeZoneStringForDateTime;
